import requests from "@/utils/request";
import store from "@/store";

let request = requests.request;
let lang = store.state.isLang != "zh-CN" ? "en_en" : "zh_cn";

// 控制台数据
export const getConsoleData = (params) =>
  request.get("/indexByBlockWatch", { lang, params });

// API续订列表
export const getApiRenewListApi = (params) =>
  request.get("/apiMember", { lang, params });

// 发送邮箱验证码
export const getEmailApi = (params) =>
  request.get("/getEmailCode", { lang, params });

// 二次验证邮箱登录---新
export const validSecondAuth = (params) =>
  request.get("/validSecondAuth", { lang, params });

// 获取邮箱验证状态 返回当前用户是否需要完成邮箱验证（用于非常用IP场景），包括是否为常用IP、是否已完成验证等信息。
export const getEmailStatus = () =>
  request.get("/emailVerificationStatus", { lang });

// 验证邮箱验证码，当前主要支持非常用IP验证场景
export const verifyEmailCodeApi = (data) =>
  request.post("/verifyEmailCode", { lang, ...data });

// 获取绑定google盾牌状态
export const getGoogleAuthStatus = (params) =>
  request.get("/getGoogleAuthStatus", { lang, params });

// 获取谷歌验证器
export const getGoogleAuth = (params) =>
  request.get("/getGoogleAuth", { lang, params });

// 绑定谷歌验证器
export const setGoogleAuth = (data) =>
  request.post("/setGoogleAuth", { lang, ...data });

// 白名单 白名单列表
export const getWhiteList = (params) =>
  request.get("/getWhiteList", { lang, params });

// 白名单 新增白名单
export const addWhiteList = (data) =>
  request.post("/addWhiteList", { lang, ...data });

// 白名单 编辑/删除白名单
export const updateWhiteList = (data) =>
  request.post("/updateWhiteList", { lang, ...data });

// 交易回调
export const getCallbackList = (params) =>
  request.get("/getCallbackList", { lang, params });

// 回调补发
export const callbackReissue = (data) =>
  request.post("/callbackReissue", { lang, ...data });

// 资产管理列表
export const getPocketList = (params) =>
  request.get("/getPocketList", { lang, params });

// 获取配置信息        上币申请时下拉框数据
export const getConfigList = (params) =>
  request.get("/getConfigList", { lang, params });

// 查看资产详情
export const getPocketInfo = (params) =>
  request.get("/getPocketInfo", { lang, params });

// 新增资产管理
export const addPocketAddress = (data) =>
  request.post("/addPocketAddress", { lang, ...data });

// 编辑资产管理
export const updatePocketAddress = (data) =>
  request.post("/updatePocketAddress", { lang, ...data });

// 修改手续费地址或者提现地址
export const updateAddress = (data) =>
  request.post("/updateAddress", { lang, ...data });

// 手续费地址或提现地址余额转到归集地址
export const withdrawToCollectApi = (data) =>
  request.post("/withdrawToCollect", { lang, ...data });

// 合约配置列表
export const listContractConfig = (params) =>
  request.get("/listContractConfig", { lang, params });

// 新增合约配置
export const createContractConfig = (data) =>
  request.post("/createContractConfig", { lang, ...data });

// 更新合约配置
export const updateContractConfig = (data) =>
  request.post("/updateContractConfig", { lang, ...data });

// 删除合约配置
export const deleteContractConfig = (data) =>
  request.post("/deleteContractConfig", { lang, ...data });

// 合约配置查看详情
export const contractLogsList = (params) =>
  request.get("/contractLogs", { lang, params });

// 获取可添加的币种列表
export const getAllTokenList = (params) =>
  request.get("/getAllTokenList", { lang, params });

// 获取用户的币种列表
export const getUserTokens = (params) =>
  request.get("/getUserTokens", { lang, params });

// 用户添加币种
export const addToken = (data) => request.post("/addToken", { lang, ...data });

// 修改币种最小数量
export const updateToken = (data) =>
  request.post("/editToken", { lang, ...data });

// 删除币种
export const deleteToken = (data) =>
  request.post("/delToken", { lang, ...data });

// 上币申请-->提交
export const addApplyToken = (data) =>
  request.post("/addApplyToken", { lang, ...data });

// 上币记录-->列表
export const getApplyTokenList = (params) =>
  request.get("/getApplyTokenList", { lang, params });

// 充币列表
export const getUpCoinList = (params) =>
  request.get("/getUpCoinList", { lang, params });

// 手动归集
export const manualCollection = (data) =>
  request.post("/manualCollection", { lang, ...data });

// 一键归集
export const oneKeyCollection = (data) =>
  request.post("/oneClickCollection", { lang, ...data });

// 充币列表--添加记录
export const setTransactionInfo = (data) =>
  request.post("/setTransactionInfo", { lang, ...data });

// 提币审核列表
export const withdrawList = (params) =>
  request.get("/withdrawList", { lang, params });

// 获取提币审核状态
export const getVerifyStatus = (params) =>
  request.get("/getVerifyStatus", { lang, params });

// 修改提币审核状态
export const setVerifyStatus = (data) =>
  request.post("/setVerifyStatus", { lang, ...data });

// 审核同意或拒绝提币
export const changeWithdrawStatus = (data) =>
  request.post("/changeWithdrawStatus", { lang, ...data });

// 批量审核同意或拒绝提币（逐笔处理可能耗时较长，不设置请求超时）
export const batchChangeWithdrawStatus = (data) =>
  request.post("/changeWithdrawStatus/batch", data, { timeout: 0 });

// 提现配置列表
export const getWithdrawConfig = (params) =>
  request.get("/getWithdrawConfig", { lang, params });

// 提现配置 更新或者删除提现配置
export const updateWithdrawConfig = (data) =>
  request.post("/updateWithdrawConfig", { lang, ...data });

// 提现配置 保存提现配置
export const addWithdrawConfig = (data) =>
  request.post("/addWithdrawConfig", { lang, ...data });

// 获取生成地址列表
export const getUserAddress = (params) =>
  request.get("/getUserAddress", { lang, params });

// 新增生成地址
export const generateAddress = (data) =>
  request.post("/generateAddress", { lang, ...data });

// 修改回调地址
export const updateCallBackUrl = (data) =>
  request.post("/updateCallBackUrl", { lang, ...data });

// 解禁
export const liftBan = (data) =>
  request.post("/allowAddress", { lang, ...data });
// 封禁
export const ban = (data) => request.post("/banAddress", { lang, ...data });
